import { ApiError, signup } from '../auth/api.js';
import { auth } from '../auth/state.js';
import type { Router } from '../router.js';
import { el, inputField } from './login.js';

export function renderSignup(container: HTMLElement, router: Router): void {
  container.innerHTML = '';
  container.classList.add('overlay-screen');

  const card = el('div', 'auth-card');
  const title = el('h1', 'auth-title');
  const titleIcon = document.createElement('img');
  titleIcon.src = '/sprites/iconchat_neutre.png';
  titleIcon.className = 'auth-title-icon';
  titleIcon.alt = '';
  title.appendChild(titleIcon);
  title.appendChild(document.createTextNode('Creuser son terrier'));
  card.appendChild(title);
  card.appendChild(el('p', 'auth-sub', '🐾 Choisis ton pseudo de chat-roi et plante ta tanière'));

  const form = document.createElement('form');
  form.className = 'auth-form';
  form.noValidate = true;

  const nameInput = inputField('Pseudo (3-24, lettres/chiffres/_-)', 'username', 'text', 'username');
  const emailInput = inputField('Email', 'email', 'email', 'email');
  const pwInput = inputField('Mot de passe (min 8)', 'password', 'password', 'new-password');
  const errBox = el('div', 'auth-error');

  const submit = document.createElement('button');
  submit.type = 'submit';
  submit.className = 'auth-submit';
  submit.textContent = '🐾 Créer mon compte';

  form.append(nameInput.wrap, emailInput.wrap, pwInput.wrap, errBox, submit);

  const switchLine = el('p', 'auth-switch');
  switchLine.innerHTML = 'Déjà un compte ? <a href="/login">Connecte-toi</a>';

  card.append(form, switchLine);
  container.appendChild(card);

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errBox.textContent = '';

    const username = nameInput.input.value.trim();
    const email = emailInput.input.value.trim();
    const password = pwInput.input.value;

    // Light client-side validation for snappier UX. Server still re-validates.
    if (username.length < 3 || username.length > 24) {
      errBox.textContent = 'Le pseudo doit faire entre 3 et 24 caractères.';
      return;
    }
    if (!/^[A-Za-z0-9_-]+$/.test(username)) {
      errBox.textContent = 'Le pseudo : lettres, chiffres, _ et - uniquement.';
      return;
    }
    if (password.length < 8) {
      errBox.textContent = 'Mot de passe : au moins 8 caractères.';
      return;
    }

    submit.disabled = true;
    submit.textContent = 'Création…';
    try {
      const user = await signup({ username, email, password });
      auth.user = user;
      router.navigate('/');
    } catch (err) {
      errBox.textContent =
        err instanceof ApiError ? err.message : 'Erreur réseau, réessaie.';
    } finally {
      submit.disabled = false;
      submit.textContent = 'Créer mon compte';
    }
  });

  setTimeout(() => nameInput.input.focus(), 0);
}
